const els = {
    $section: () => $('[data-timeline-section]'),
    $frame: () => els.$section().find('[data-frame]'),
    $heading: () => els.$section().find('[data-heading]'),
    $headingText: () => els.$heading().find('[data-text]'),
    $headingPole: () => els.$heading().find('[data-pole]'),
    $buttons: () => els.$heading().find('[data-buttons]'),
    $prevButton: () => els.$heading().find('[data-previous]'),
    $nextButton: () => els.$heading().find('[data-next]'),
    $timeline: () => els.$section().find('[data-timeline]'),
    $slidesWrap: () => els.$timeline().find('[data-slides]'),
    $slides: () => els.$timeline().find('[data-slide]'),
    $slide: (index) => els.$slides().eq(index),
    $slideContent: (index) => els.$slide(index).find('[data-content]'),
    $slideGraphic: (index) => els.$slide(index).find('[data-graphic]'),
    $slidesContents: () => els.$slides().find('[data-content]'),
    $slidesGraphics: () => els.$slides().find('[data-graphic]'),
    $plot: () => els.$timeline().find('[data-plot]'),
    $pointsWrap: () => els.$timeline().find('[data-points]'),
    $points: () => els.$timeline().find('[data-point]'),
    $point: (index) => els.$points().eq(index),
    $dots: () => els.$points().find('[data-dot]'),
    $dot: (index) => els.$point(index).find('[data-dot]'),
    $years: () => els.$timeline().find('[data-year]'),
    $year: (index) => els.$years().eq(index),
    $plotLineWrap: () => els.$plot().find('[data-lines]'),
    $plotLineFill: () => els.$plot().find('[data-line]'),
    $plotDotRings: () => els.$plot().find('[data-dot-ring]'),
};

export default els;

